import React from 'react';
import LoadingSpinner from './Loading/Loading';

const BaseTable = ({
    title = 'Categories',
    columns = [],
    data = [],
    loading = false,
    isEmptyMessage = 'No data found',
}) => {
    return (
        <div className="bg-white rounded-2xl overflow-hidden">
            <div className="mx-auto">
                <div className="rounded-sm shadow bg-white">
                    <div className="px-8 py-6 flex flex-wrap lg:flex-nowrap items-center md:justify-between border-b border-gray-200">
                        <div className="min-w-full lg:min-w-0 flex-1 lg:mb-0">
                            <h2 className="text-lg font-bold text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
                                {title || ''}
                            </h2>
                        </div>
                    </div>
                    <div className="overflow-x-auto">
                        <table className="table-auto w-full">
                            <thead className="text-xs font-semibold uppercase text-gray-400 bg-slate-100">
                                <tr>
                                    {columns?.map((col) => (
                                        <th
                                            key={col?.key}
                                            scope="col"
                                            className={col?.className || "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"}
                                        >
                                            {col?.label || 0}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className="text-sm divide-y divide-gray-100">
                                {loading ? (
                                    <tr>
                                        <td colSpan={columns?.length}>
                                            <div className="flex items-center justify-center">
                                                <LoadingSpinner />
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    <>
                                        {data?.map((row) => (
                                            <tr key={row?._id} className="border-b border-gray-200 even:bg-slate-50">
                                                {columns?.map((col) => (
                                                    <td key={col?.key} className={col?.cellClassName || "px-3 py-4 text-sm text-gray-500"}>
                                                        {col?.render ? col?.render(row) : row[col?.key]}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </>
                                )}
                                {data?.length === 0 && !loading && (
                                    <tr>
                                        <td colSpan={columns?.length} className="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">
                                            <p className="text-gray-500 text-sm text-center">{isEmptyMessage}</p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BaseTable;
